import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useEffect, useRef } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';

import BonusIcon from '../../../../assets/icons/bonus-white.svg';

import { TXTWCL_Bonus_selected, TXTWCL_Select_this_bonus } from './BonusContainer.messages.json';
import {
  active,
  bonusIcon,
  button,
  buttonText,
  container,
  header,
  selectedItem,
  wrapper
} from './BonusContainer.scss';

interface Props {
  selected?: boolean;
  title?: TranslationTag;
  children?: React.ReactNode;
}

const BonusContainer: React.FC<Props> = ({ selected, title, children }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (selected && containerRef.current !== null) {
      scrollIntoView(containerRef.current, { scrollMode: 'if-needed', behavior: 'smooth' });
    }
  }, [selected]);

  return (
    <div ref={containerRef} className={classNames(container, selected && selectedItem)}>
      {title && (
        <div className={wrapper}>
          <div className={header}>
            <Translation {...title} />
          </div>
        </div>
      )}
      {children}
      <div className={classNames(button, selected && active)}>
        <div className={buttonText}>
          {selected && (
            <i className={bonusIcon}>
              <BonusIcon />
            </i>
          )}
          {selected ? (
            <Translation {...TXTWCL_Bonus_selected} />
          ) : (
            <Translation {...TXTWCL_Select_this_bonus} />
          )}
        </div>
      </div>
    </div>
  );
};

export default BonusContainer;
